export type EventsTimeRange = 'upcoming' | 'includePast';

/** Local midnight for the given calendar day (defaults to today). */
export function getStartOfLocalDay(date = new Date()): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

/** First day of the previous calendar month at local midnight. */
export function getStartOfPreviousCalendarMonth(date = new Date()): Date {
  const d = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function formatPreviousMonthLabel(date = new Date()): string {
  const d = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

/**
 * Default: only events that have not ended yet (endTime >= start of today).
 * Include past: events starting on or after the 1st of the previous calendar month
 * (at most ~62 days of history: full previous month + current month to date).
 */
export function eventsTimeRangeFilters(range: EventsTimeRange) {
  if (range === 'upcoming') {
    return { minEndTime: getStartOfLocalDay().toISOString() };
  }
  return { startDate: getStartOfPreviousCalendarMonth().toISOString() };
}

/** True when the event has fully ended (before start of today, local time). */
export function isEventConcluded(endTime: string | Date): boolean {
  return new Date(endTime) < getStartOfLocalDay();
}
